import { formatDuration } from '@lunary/app-core/format-duration'
import { VoiceMessage } from '@lunary/ui-web/voice-message'
import type { VoiceRecorder } from '@lunary/ui-web/voice-recorder'
import { VoiceWave } from '@lunary/ui-web/voice-wave'
import styles from './readings.module.css'

const BARS = 64

export function VoiceRecorderBox({ rec, busy }: { rec: VoiceRecorder; busy: boolean }) {
  if (rec.status === 'unsupported') return <p className="error-box">Этот браузер не умеет записывать звук. Откройте админку в Chrome или Safari.</p>

  if (rec.status === 'preview' && rec.recording) {
    return (
      <div className={styles.recorder}>
        <div className={styles.recPreview}>
          <VoiceMessage id={`draft-${rec.recording.url}`} src={rec.recording.url} durationMs={rec.recording.durationMs} peaks={rec.recording.peaks} size="compact" />
        </div>
        <button type="button" className="secondary" disabled={busy} onClick={rec.discard}>
          Перезаписать
        </button>
      </div>
    )
  }

  if (rec.status === 'recording' || rec.status === 'paused' || rec.status === 'requesting') {
    const paused = rec.status === 'paused'
    return (
      <div className={styles.recorder}>
        <span className={styles.recDot} data-paused={paused} aria-hidden="true" />
        <span className={styles.recTime}>{formatDuration(rec.elapsedMs)}</span>
        <VoiceWave peaks={rec.levels.slice(-BARS)} progress={0} bars={Math.min(BARS, Math.max(1, rec.levels.length))} className={styles.recWave} />
        <button type="button" className="secondary" onClick={paused ? rec.resume : rec.pause} disabled={rec.status === 'requesting'}>
          {paused ? 'Продолжить' : 'Пауза'}
        </button>
        <button type="button" onClick={rec.stop} disabled={rec.status === 'requesting'}>
          Готово
        </button>
        <button type="button" className={styles.linkBtn} onClick={rec.discard}>
          Удалить
        </button>
      </div>
    )
  }

  return (
    <div className={styles.recorder}>
      <button type="button" className={styles.recStart} onClick={() => void rec.start()} disabled={busy}>
        <span className={styles.recDot} aria-hidden="true" />
        Записать голосовой разбор
      </button>
      <span className="muted">до 10 минут, можно ставить на паузу</span>
      {rec.status === 'denied' && <p className="error-box">Нет доступа к микрофону. Разрешите его в настройках браузера.</p>}
    </div>
  )
}
